<!-- board type selector -->
<div
  #boardTypeSelector
  *ngIf="
    ipBoardPart.signOptionSelected &&
    ((ipBoardPart.sign != null &&
      ipBoardPart.sign.type?.value !== SIGN_TYPE_CHOICES.STICKER.value) ||
      ipBoardPart.otherIPBoardPartType?.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal ||
      (ipBoardPart.otherWidth != null && ipBoardPart.otherHeight != null))
  "
>
  <div class="ip-board-form-title">
    <div class="form-title-text">
      Kies een bordtype
    </div>
  </div>
  <ng-container
    *ngIf="
      (ipBoardPart.sign != null &&
        ipBoardPart.sign.type?.value !== SIGN_TYPE_CHOICES.STICKER.value) ||
      (ipBoardPart.sign == null &&
        ipBoardPart.otherIPBoardPartType?.ordinal !==
          IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal)
    "
  >
    <div
      class="form-section-padding board-or-placement-type-selector selector-background-color"
    >
      <div
        *ngFor="
          let option of isLeftRight
            ? IP_BOARD_LEFT_RIGHT_BOARD_OPTIONS_ARRAY
            : IP_BOARD_BOARD_OPTIONS_ARRAY
        "
        class="board-or-placement-option"
        [ngClass]="
          selectedBoardTypeOption === option
            ? 'selected-option'
            : 'unselected-option'
        "
        (click)="selectBoardOption(option)"
      >
        <div class="option-preview-container">
          <div class="option-preview">
            <img width="185" height="170" src="{{ option.previewUrl }}" />
          </div>
        </div>
        <hr />
        <div class="option-label board-or-placement-option-label-margin">
          {{ option.label }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      ipBoardPart.sign == null &&
      ipBoardPart.otherIPBoardPartType?.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
    "
  >
    <div
      class="form-section-padding d-flex selector-background-color adhesive-measurements-min-height"
    >
      <div class="flex-1">
        <mat-radio-group
          [value]="customSelectedRightOption"
          (change)="setCustomSelectedRightOption($event.value)"
        >
          <div class="flex-column">
            <mat-radio-button
              *ngFor="let option of CUSTOM_SIGN_ADHESIVE_OPTIONS_ARRAY"
              [value]="option"
              [checked]="customSelectedRightOption === option"
            >
              <span class="preserve-span-space">{{ option.label }} </span>
              <span class="smaller-text">{{ option.smallerLabel }}</span>
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
      <div class="flex-2">
        <img
          *ngIf="
            customSelectedRightOption != null &&
            customSelectedRightOption.previewUrl?.length > 0
          "
          class="adhesive-preview"
          src="{{ customSelectedRightOption.previewUrl }}"
        />
      </div>
    </div>
  </ng-container>
</div>

<!-- placement type selector -->
<div
  #placementTypeSelector
  class="upper-space"
  *ngIf="
    selectedBoardTypeOption != null &&
    (ipBoardPart.otherIPBoardPartType?.ordinal !==
      IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal ||
      (ipBoardPart.otherIPBoardPartType?.ordinal !==
        IP_BOARD_PART_TYPE_CHOICES.OTHER_DIMENSIONS.ordinal &&
        ipBoardPart.otherHeight != null &&
        ipBoardPart.otherWidth != null) ||
      customSelectedRightOption != null)
  "
>
  <div class="ip-board-form-title">
    <div class="form-title-text">
      Kies een plaatsingsmethode
    </div>
  </div>
  <ng-container
    *ngIf="
      (ipBoardPart.sign != null &&
        ipBoardPart.sign.type?.value === SIGN_TYPE_CHOICES.STICKER.value) ||
      (ipBoardPart.sign == null &&
        ipBoardPart.otherIPBoardPartType?.ordinal ===
          IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal)
    "
  >
    <div
      class="form-section-padding board-or-placement-type-selector selector-background-color"
    >
      <div
        *ngFor="let option of V_ADHESIVE_PLACEMENT_OPTIONS_ARRAY"
        class="board-or-placement-option"
        [ngClass]="
          selectedPlacementTypeOption === option
            ? 'selected-option'
            : 'unselected-option'
        "
        (click)="selectPlacementOption(option)"
      >
        <div class="option-preview-container">
          <div class="option-preview">
            <img width="185" height="170" src="{{ option.previewUrl }}" />
          </div>
        </div>
        <hr />
        <div class="option-label board-or-placement-option-label-margin">
          {{ option.label }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      (ipBoardPart.sign != null &&
        ipBoardPart.sign.type?.value !== SIGN_TYPE_CHOICES.STICKER.value) ||
      (ipBoardPart.sign == null &&
        (ipBoardPart.otherIPBoardPartType == null ||
          ipBoardPart.otherIPBoardPartType.ordinal !==
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal))
    "
  >
    <div
      class="form-section-padding board-or-placement-type-selector selector-background-color"
    >
      <ng-container
        *ngIf="selectedBoardTypeOption === IP_BOARD_BOARD_OPTIONS.SINGLE_SIDED"
      >
        <div
          *ngFor="let option of SINGLE_SIDED_PLACEMENT_OPTIONS_ARRAY"
          class="board-or-placement-option"
          [ngClass]="
            selectedPlacementTypeOption === option
              ? 'selected-option'
              : 'unselected-option'
          "
          (click)="selectPlacementOption(option)"
        >
          <div class="option-preview-container">
            <div class="option-preview">
              <img width="185" height="170" src="{{ option.previewUrl }}" />
            </div>
          </div>
          <hr />
          <div class="option-label board-or-placement-option-label-margin">
            {{ option.label }}
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="selectedBoardTypeOption === IP_BOARD_BOARD_OPTIONS.DOUBLE_SIDED"
      >
        <div
          *ngFor="let option of DOUBLE_SIDED_PLACEMENT_OPTIONS_ARRAY"
          class="board-or-placement-option"
          [ngClass]="
            selectedPlacementTypeOption === option
              ? 'selected-option'
              : 'unselected-option'
          "
          (click)="selectPlacementOption(option)"
        >
          <div class="option-preview-container">
            <div class="option-preview">
              <img width="185" height="170" src="{{ option.previewUrl }}" />
            </div>
          </div>
          <hr />
          <div class="option-label board-or-placement-option-label-margin">
            {{ option.label }}
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="selectedBoardTypeOption === IP_BOARD_BOARD_OPTIONS.V"
      >
        <div
          *ngFor="let option of V_IP_BOARD_PLACEMENT_OPTIONS_ARRAY"
          class="board-or-placement-option"
          [ngClass]="
            selectedPlacementTypeOption === option
              ? 'selected-option'
              : 'unselected-option'
          "
          (click)="selectPlacementOption(option)"
        >
          <div class="option-preview-container">
            <div class="option-preview">
              <img width="185" height="170" src="{{ option.previewUrl }}" />
            </div>
          </div>
          <hr />
          <div class="option-label board-or-placement-option-label-margin">
            {{ option.label }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
